import { Injectable } from '@angular/core';
import { MyAccountAnalyticsService } from '@shared/data-access/services';
import { Order } from '@shared/data-access/interfaces';

@Injectable({providedIn: 'root'})
export class TrackOrdersAnalyticsTranslator {

	toViewModel(order: Order, analyticsService: MyAccountAnalyticsService) {
		analyticsService.setOrderId(order.orderNumber.toString());

		const adjustments = order.adjustments.concat(order.manualAdjustments).filter((x) => x.displayLevel === 'Order' && x.calUsageId !== -7);

		const orderLevelAdjustments = adjustments.map((x) => this.getValueString(Math.abs(x.amount)));

		if (orderLevelAdjustments.length === 0) {
			orderLevelAdjustments.push('');
		}

		analyticsService.setOrderLevelPromoAmounts(orderLevelAdjustments);

		const productArray = order.items.map((x) => ({
				FulfillmentStore: x.fulfillmentStore,
				ProductQty: x.quantity.toString(),
				ShippingPaidPerUnit: this.getValueString(x.shippingPaidPerUnit),
				ProductID: x.productID,
				PromotionsApplied: x.adjustments.map((y) => ({
						OrderVsItemLevel: y.displayLevel === 'OrderItem' ? 'Item' : y.displayLevel,
						Amount: this.getValueString(Math.abs(y.amount)),
						PromoID: y.promotionId.toString(),
						CustomerCode: ''
					})),
				ItemDiscountPerUnit: this.getValueString(x.itemDiscountPerUnit),
				ProductSKU: x.sku,
				CurrentPricePerUnit: this.getValueString(x.totalPrice / x.quantity),
				ShippingDiscountPerUnit: this.getValueString(x.shippingDiscountPerUnit),
				DistributedOrderDiscountPerUnit: this.getValueString(x.distributedOrderDiscountPerUnit),
				ListPricePerUnit: this.getValueString(x.unitPrice),
				TaxPerUnit: this.getValueString(x.taxPerUnit),
				FulfillmentMethod: x.fulfillmentMethod
			}));

		analyticsService.setProductArray(productArray);

		analyticsService.setTaxTotal(this.getValueString(order.totalTax));

		const totalDiscount = adjustments.map((x) => x.amount).reduce((a, b) => a + b, 0);
		analyticsService.setTotalOrderDiscount(this.getValueString(Math.abs(totalDiscount)));

		analyticsService.setShippingMethod(order.items.map((x) => x.shipModeCode));

		analyticsService.setEventType('TrackOrderClick');
	}

	toTrackOrderError(id: string, message: string, analyticsService: MyAccountAnalyticsService) {
		analyticsService.setErrorId(id);
		analyticsService.setErrorMessage(message);
		analyticsService.setEventType('SiteError');
	}

	resetTrackOrderFields(analyticsService: MyAccountAnalyticsService) {
		analyticsService.resetFields('ErrorId', 'ErrorMessage', 'EventType', 'OrderID', 'OrderLevelPromoAmounts', 'ProductArray', 'ShippingMethod', 'TaxTotal', 'TotalOrderDiscount');
	}

	private getValueString(amount: number): string {
		return amount.toFixed(2).toString();
	}
}
